import NewsletterSignup from "@/components/NewsletterSignup";

const NewsletterToliau = () => {
  return (
    <section className="bg-cream py-24 relative overflow-hidden">
      <div className="container mx-auto px-6 max-w-4xl text-center">
        <div className="mb-12">
          <span className="text-[11px] tracking-[0.22em] uppercase text-ink/55 font-semibold">— Next —</span>
          <h2 className="font-marquee text-3xl md:text-5xl font-bold text-ink mt-3 mb-4">
            New work
          </h2>
          <p className="text-ink/75 text-lg leading-relaxed whitespace-pre-line">
            Be the first to know{"\n"}
            what we are making right now.{"\n"}
            {"\n"}
            {"\n"}
          </p>
        </div>

        <div className="max-w-md mx-auto">
          <p className="text-xs uppercase tracking-widest text-ink/40 font-bold mb-6">Join the newsletter</p>
          <NewsletterSignup />
          <p className="text-[10px] text-ink/40 mt-6 leading-relaxed">
            By subscribing you agree to receive our emails. Your data is safe and you can unsubscribe at any time.
          </p>

        </div>
      </div>

      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-yellow/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 -z-1" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-terracotta/5 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2 -z-1" />
    </section>
  );
};

export default NewsletterToliau;
